module.exports = __webpack_public_path__ + "img/download_icon.8f0fbd83.svg";